import { MlbTeamMarkImage } from './MlbTeamMarkImage';

type PlayerPickAvatarProps = {
  displayImageUrl: string;
  alt: string;
  initials: string;
  /** When true, show a desaturated team mark behind the headshot (league IP contests). */
  leagueIpEnabled: boolean;
  teamCode: string;
  /** Sport code (e.g. 'MLB', 'NBA', 'NFL'). Used for sport-aware asset paths. */
  sport?: string | null;
  /** `contain` keeps full jersey visible (NFL prop pick card). */
  objectFit?: 'cover' | 'contain';
  className?: string;
};

/**
 * 72×72 player image: optional team mark (SVG or jersey PNG) behind the headshot, same treatment as CardSelectView.
 */
export function PlayerPickAvatar({
  displayImageUrl,
  alt,
  initials,
  leagueIpEnabled,
  teamCode,
  sport,
  objectFit = 'cover',
  className,
}: PlayerPickAvatarProps) {
  return (
    <div
      className={`relative h-[72px] w-[72px] shrink-0 overflow-hidden rounded-[10px] bg-[#2a2a2a] ${className ?? ''}`}
    >
      {leagueIpEnabled ? (
        <MlbTeamMarkImage
          teamCode={teamCode}
          sport={sport}
          className="pointer-events-none absolute inset-0 z-0 h-full w-full object-contain opacity-[0.38]"
          style={{
            filter: 'saturate(0)',
            transform: 'scale(1.2)',
            objectPosition: 'center center',
          }}
        />
      ) : null}
      {displayImageUrl ? (
        <img
          src={displayImageUrl}
          alt={alt}
          className={`relative z-[1] h-full w-full ${objectFit === 'contain' ? 'object-contain p-1' : 'object-cover'}`}
        />
      ) : (
        <div className="relative z-[1] flex h-full w-full items-center justify-center text-[18px] font-bold text-white/30">
          {initials}
        </div>
      )}
    </div>
  );
}
